import React from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import { useFormik } from "formik"
import * as Yup from "yup"
import { request } from "../../services/request"
import { Form } from 'react-bootstrap'
import PrimaryButton from '../../components/subComponents/PrimaryButton'

const AddCustomer = () => {
    const Icon: any = FaChevronLeft
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false)

    const validationSchema = Yup.object().shape({
        fName: Yup.string().required("Please enter First Name"),
        lName: Yup.string().required("Please enter Last Name"),
        email: Yup.string().required("Please enter Email"),
    })

    const navigate = useNavigate()

    const formik = useFormik({
        initialValues: {
            fName: "",
            lName: "",
            email: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsSubmitting(true)
            try {
                const payload = {
                    first_name: values.fName,
                    last_name: values.lName,
                    email: values.email,
                }
                const response = await request({
                    url: `/adminCustomers/createCustomer`,
                    method: "POST",
                    data: payload,
                })
                if (response.success) {
                    toast.success(response.message)
                    formik.resetForm()
                    navigate(`/customers`)

                } else {
                    toast.error(response.message)
                }
            } catch (error: any) {
                toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
            } finally {
                setIsSubmitting(false)
            }
        },
    })

    const getBack = () => {
        navigate(-1)
    }
    return (
        <section className='dashboard-section'>
            <ToastContainer position='top-right' autoClose={2000} theme='light' />

            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <div className='d-flex gap-1 customer-detail-line'>
                            <button onClick={getBack} className='d-flex align-items-center'>
                                <Icon size={20} />
                            </button>
                            <div className='dashboard-table-title-section'>
                                <h2>Add Customer</h2>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-8 col-lg-10 col-md-10 col-12 mt-4'>
                        <div>
                            <form onSubmit={formik.handleSubmit} className='customer-edit-form'>
                                <div className='login-input-section'>
                                    <label htmlFor='fName'>First Name</label>
                                    <Form.Control
                                        type='text'
                                        name='fName'
                                        id='fName'
                                        placeholder='Please enter First Name'
                                        value={formik.values.fName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        min={1}
                                        isInvalid={!!formik.errors.fName && formik.touched.fName}
                                    />
                                    <span className='text-red-500 text-xs'>{formik.errors.fName}</span>
                                </div>
                                <div className='login-input-section'>
                                    <label htmlFor='lName'>Last Name</label>
                                    <Form.Control
                                        type='text'
                                        name='lName'
                                        id='lName'
                                        placeholder='Please enter Last Name'
                                        value={formik.values.lName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        min={1}
                                        isInvalid={!!formik.errors.lName && formik.touched.lName}
                                    />
                                    <span className='text-red-500 text-xs'>{formik.errors.lName}</span>
                                </div>
                                <div className='login-input-section'>
                                    <label htmlFor='email'>Email</label>
                                    <Form.Control
                                        type='text'
                                        name='email'
                                        id='email'
                                        placeholder='Please enter Email'
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        min={1}
                                        isInvalid={!!formik.errors.email && formik.touched.email}
                                    />
                                    <span className='text-red-500 text-xs'>{formik.errors.email}</span>
                                </div>
                                <div className='login-input-section input-section mb-3'>
                                    <div>
                                        <label htmlFor='role'>Role</label>
                                    </div>
                                    <Form.Select
                                        name='role'
                                        value={"0"}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        disabled={true}
                                    >
                                        <option value='0'>Owner</option>
                                    </Form.Select>
                                </div>
                                <PrimaryButton disabled={isSubmitting} type='submit' label={isSubmitting ? "Creating..." : 'Create'} className={`editFormButton mx-0 mt-3 w-fit ${isSubmitting ? "cursor-not-allowed" : ""}`} />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddCustomer
